import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LocaleService } from '@career/core/services/locale.service';

@Component({
  selector: 'app-cielo-opportunities',
  templateUrl: './cielo-opportunities.component.html',
  styleUrls: ['./cielo-opportunities.component.scss']
})
export class CieloOpportunitiesComponent implements OnInit {

  @Input() scope;
  resumeOrCvText = this.localeService.getResumeOrCVText();
  filtersOpen = false;

  constructor(private localeService: LocaleService, private sanitizer: DomSanitizer) {}

  getSafeVideoUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit(): void {}

  resetSearch() {
    this.scope.params.keywords = '';
    this.scope.params.jobLabel = '';
    this.scope.params.careerLevel = '';
    this.scope.params.compensation = '';
    this.scope.params.location.setValue(null);
    this.scope.search();
  }

  clearJobLabel() {
    this.scope.params.jobLabel = '';
    this.scope.search();
  }

  clearCareerLevel() {
    this.scope.params.careerLevel = '';
    this.scope.search();
  }

  toggleRemote(checked: boolean) {
    this.scope.params.compensation = checked ? 'remote' : '';
    this.scope.search();
  }

  isRemoteChecked(): boolean {
    return this.scope.params.compensation === 'remote';
  }

  getEmploymentType(opp): string {
    const pill = (opp.display?.pills || []).find(p =>
      ['full-time', 'part-time', 'contract', 'temporary', 'internship'].some(t =>
        p.value?.toLowerCase().includes(t)
      )
    );
    return pill ? pill.value : null;
  }

}

